import Schematic from './Schematic';

export default Schematic;
